import Vue from 'vue';
import Vuex from 'vuex';
import VueMomentLib from 'vue-moment-lib';
import Vuelidate from 'vuelidate';
import MdVuelidated from '@undecaf/vue-material-vuelidate';
import {
  MdApp, MdButton, MdCard, MdCheckbox, MdContent, MdDialog, MdDialogConfirm, MdDrawer, MdEmptyState,
  MdField, MdIcon, MdList, MdMenu, MdProgress, MdSnackbar, MdSubheader, MdTable, MdTabs, MdToolbar,
  MdTooltip,
} from 'vue-material/dist/components';
import { Datetime } from 'vue-datetime';
import '@undecaf/vue-material-vuelidate/dist/components.css';
import 'vue-material/dist/vue-material.min.css';
import 'vue-datetime/dist/vue-datetime.css';
import 'vue-material/dist/theme/default.css';
import '@/assets/global.scss';
import moment from 'moment';
import i18n from '@/i18n';

import App from './App.vue';
import router from './router';

Vue.use(VueMomentLib);
Vue.use(Vuex);
Vue.use(MdApp);
Vue.use(MdButton);
Vue.use(MdCard);
Vue.use(MdCheckbox);
Vue.use(MdContent);
Vue.use(MdDialog);
Vue.use(MdDialogConfirm);
Vue.use(MdDrawer);
Vue.use(MdEmptyState);
Vue.use(MdField);
Vue.use(MdIcon);
Vue.use(MdList);
Vue.use(MdMenu);
Vue.use(MdProgress);
Vue.use(MdSubheader);
Vue.use(MdSnackbar);
Vue.use(MdTable);
Vue.use(MdTabs);
Vue.use(MdToolbar);
Vue.use(MdTooltip);
Vue.use(Datetime);
Vue.use(Vuelidate);
Vue.use(MdVuelidated);

Vue.config.productionTip = false;

Vue.filter('toCurrency', (value) => {
  const currency = process.env.VUE_APP_CURRENCY;

  if (typeof value !== 'number') {
    return value;
  }

  const dollars = (value / 100);

  const formatter = new Intl.NumberFormat('en-AU', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return `${currency.toUpperCase()} ${formatter.format(dollars)}` as string;
});

Vue.filter('dateString', (value) => moment(value).format('DD/MM/YYYY HH:mm:ss'));

Vue.prototype.$billingProviderUrl = {
  stripe: {
    customer: (customerId) => `${process.env.VUE_APP_PROVIDER_BASEURL}/customers/${customerId}`,
    subscription: (subscriptionId) => `${process.env.VUE_APP_PROVIDER_BASEURL}/subscriptions/${subscriptionId}`,
    price: (priceId) => `${process.env.VUE_APP_PROVIDER_BASEURL}/prices/${priceId}`,
    invoice: (invoiceId) => `${process.env.VUE_APP_PROVIDER_BASEURL}/invoices/${invoiceId}`,
    product: (productId) => `${process.env.VUE_APP_PROVIDER_BASEURL}/products/${productId}`,
  },
};

const store = new Vuex.Store({
  state: {
    logged: false,
    errorMessage: '',
  },
  mutations: {
    logout(state) {
      state.logged = false;
    },
    login(state) {
      state.logged = true;
    },
    errorMessage(state, message) {
      state.errorMessage = message;
    },
  },
  getters: {
    logged: (state) => state.logged,
  },
});

Vue.prototype.$snackbar = {
  message: ((message) => {
    if (typeof message !== undefined) {
      store.commit('errorMessage', message);
    }
  }),
};

new Vue({
  router,
  render: (h) => h(App),
  store,
  i18n,
}).$mount('#app');
